import subjectsRepository from './subjectsRepository';

export default class SubjectsPresenter {
  getSubjects() {
    return subjectsRepository.subjects;
  }

  updateSubjects(subjects) {
    subjectsRepository.updateSubjects(subjects);
  }
}
